import { render, staticRenderFns } from "./MapaFiscais.vue?vue&type=template&id=039b7910&"
import script from "./MapaFiscais.vue?vue&type=script&lang=js&"
export * from "./MapaFiscais.vue?vue&type=script&lang=js&"
import style0 from "./MapaFiscais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAutocomplete,VCard,VCardText,VCol,VExpandTransition})
